import { render, staticRenderFns } from "./MessagingViewTest.vue?vue&type=template&id=300319b6"
import script from "./MessagingViewTest.vue?vue&type=script&lang=js"
export * from "./MessagingViewTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports